import { render, staticRenderFns } from "./DocumentH5.vue?vue&type=template&id=3ae335b8"
import script from "./DocumentH5.vue?vue&type=script&lang=js"
export * from "./DocumentH5.vue?vue&type=script&lang=js"
import style0 from "./DocumentH5.vue?vue&type=style&index=0&id=3ae335b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports